import { InjectionToken } from '@angular/core'
import { SearchOptions } from 'instantsearch.js'

export const MAX_SELECTED_PRODUCTS_COUNT = 5000

export interface ProductEanBrowseSource {
    browseMatchingEans(
        search: SearchOptions,
        onEan: (ean: string) => void,
        maxSelectedProductsCount?: number,
    ): Promise<void>
}

export const PRODUCT_EAN_BROWSE_SOURCE = new InjectionToken<ProductEanBrowseSource>('PRODUCT_EAN_BROWSE_SOURCE')
